@if ((isLoading | async); as loadingState) {
  <div class="spinner-overlay">
    <div class="spinner-frame">
      <svg class="spinner" viewBox="0 0 50 50">
        <circle class="outer-path" cx="25" cy="25" r="21" fill="none" stroke-width="3.5"></circle>
        <circle class="path" cx="25" cy="25" r="21" fill="none" stroke-width="3.5"></circle>
      </svg>
    </div>
  </div>
}